<ng-container>

    <ng-container *ngIf="notification$ | async as data">
        <ng-container *ngIf="data?.data?.HideComponentOnSite?.data ==='false'">
            <app-website-notification *ngIf="!closeExpiredNotificationDiv" [notificationData]="data"
                (closeNotification)="closeNotificationEvent($event)"
                (closeExpiredNotification)="closeExpiredNotificationEvent($event)"></app-website-notification>
        </ng-container>
    </ng-container>
<ng-container>
    <a href="#main-content" class="visually-hidden focusable skip-link" role="button" aria-label="Skip to main content">Skip to main content</a>
</ng-container>
    <ng-container *ngIf="pageName">
        <app-das-header [dasSticky]="isSticky" [dasPage]="pageName" [newHeaderDesktop]="isNewHeaderDesk"
            *ngIf="isNewHF; else otherHeader"></app-das-header>
        <ng-template #otherHeader>
            <app-header [sticky]="isSticky" [page]="pageName"></app-header>
        </ng-template>
    </ng-container>
    <main id="main-content">
        <router-outlet></router-outlet>
    </main>
    <div [innerHTML]="customMetaService.schemaScript" *ngIf="customMetaService.schemaScript!=''"></div>
    <!-- <ng-container *ngIf="isBrowser()"> -->
    <app-cookie-policy (hideConsent)="consentFlag = $event" *ngIf="consentFlag == 'false' && !isGuestGuidePage">
    </app-cookie-policy>
    <!-- </ng-container> -->
    <ng-container *ngIf="pageName">
        <app-das-footer *ngIf="isNewHF; else otherHeader"></app-das-footer>
        <ng-template #otherHeader>
            <app-footer [islandingPage]="islandingPage"></app-footer>
        </ng-template>
    </ng-container>
<!-- </ng-container> -->
<!-- <div class="overlay"></div> -->
</ng-container>
<!-- <app-hello-world></app-hello-world> -->